import swal from "sweetalert2";

export async function showNotConnectedOnRefreshError() {
	return swal.fire({
		title: "Error!",
		html:
			`The current configuration is out of date and must be reloaded but the device is not connected to the internet.
				<br/>
				<br/>
				Please reconnect to the internet, click the refresh button, and try again.`,
		type: "error",
		allowOutsideClick: false,
		allowEscapeKey: false,
		allowEnterKey: false,
		confirmButtonText: "Refresh"
	})
		.then(res => {
			if(!!res) {
				location.reload();
			}
		});
}